import { render, staticRenderFns } from "./MarketReportList.vue?vue&type=template&id=0ca98a26"
import script from "./MarketReportList.vue?vue&type=script&lang=js"
export * from "./MarketReportList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports